import React from 'react';
import { render } from './render';
var imgStyle = { maxWidth: '100%' };
export function renderAnswer(content, skillApi, cardId) {
    var t = render(content, skillApi, cardId);
    if (content.image) {
        return (React.createElement(React.Fragment, null,
            t,
            !content.text ? null : React.createElement("br", null),
            React.createElement("a", { href: content.image, target: "_blank", rel: "noopener" },
                React.createElement("img", { src: content.image, style: imgStyle }))));
    }
    return t;
}
//# sourceMappingURL=renderAnswer.js.map